import { PublicLayout } from './containers'

export default PublicLayout